import React, { Component } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import Routes from "./Routes";
import "./App.css";

const oktaAuth = new OktaAuth({
  issuer: "https://cspmeds.okta.com/oauth2/default",
  clientId: "0oa1kj0rnogBQ3FMW4h7",
  redirectUri: window.location.origin + "/login/callback",
});

class App extends Component {
  constructor(props) {
    super(props);
    this.restoreOriginalUri = async (_oktaAuth, originalUri) => {
      props.history.replace(
        toRelativeUrl(originalUri || "/", window.location.origin)
      );
    };
  }

  render() {
    return (
      <Security
        oktaAuth={oktaAuth}
        restoreOriginalUri={this.restoreOriginalUri}
      >
        <Routes />
      </Security>
    );
  }
}

const AppWithRouterAccess = withRouter(App);

class RouterApp extends Component {
  render() {
    return (
      <Router>
        <AppWithRouterAccess />
      </Router>
    );
  }
}

export default RouterApp;
